import { createContext, useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { useSelector } from '@tabeeb/store'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import { useApi } from '@tabeeb/modules/shared/utils/API'
import { getIsTrainingMaterialsEnabled } from '@tabeeb/modules/appConfigState/selectors'

import { ArticlesQueryKeys } from '../queries'

const UnreadTrainingMaterialsContext = createContext({
  unreadTrainingMaterialsCount: 0,
})

export const UnreadTrainingMaterialsContextProvider: React.FC = ({ children }) => {
  const { articleServiceApi: api } = useApi()

  const contentId = useSelector<number | undefined>(getContentId)
  const isTrainingMaterialsFeatureEnabled = useSelector(getIsTrainingMaterialsEnabled)

  const query = useQuery({
    queryKey: [ArticlesQueryKeys.UnreadTrainingMaterialsCount, contentId],
    queryFn: () => api.contentTrainingMaterials.getUnreadCountAsync({ contentId: contentId! }),
    enabled: !!contentId && isTrainingMaterialsFeatureEnabled,
  })

  const value = useMemo(
    () => ({
      unreadTrainingMaterialsCount: query.data ?? 0,
    }),
    [query.data]
  )

  return <UnreadTrainingMaterialsContext.Provider value={value}>{children}</UnreadTrainingMaterialsContext.Provider>
}

export default UnreadTrainingMaterialsContext
